// @ts-check
import { FormaRecuento } from '@erpagroapp/common';
import { defineConfig } from '../utils';

export function inventoryRegularization() {
  return defineConfig({
    properties: {
      'InventarioRegularizacion.FormaRecuento': {
        /** @type {typeof FormaRecuento[keyof FormaRecuento]} */
        defaultValue: FormaRecuento.Recuento,
      },
    },
  });
}
